import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class ShowViewerCount extends BaseOption {
  static userInterfaceComponent = {
    label: "Show Participant Count",
    optionDataType: BaseOption.DataType.Boolean,
    component: inspectorTools.RADIO_BAR,
    descriptionMessage: "How many people have joined (viewers, on a livestream), shown during the call and on the join card.",
    props: {
      options: [
        {
          label: "Yes",
          value: true,
          tooltip: "",
        },
        {
          label: "No",
          value: false,
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = true;

  static convertConfigValueToCompiledValue(configValue) {
    return [true, "true", "yes"].includes(configValue);
  }
}
